export const productDevelopmentDashboardTr = {
  title: 'Ürün geliştirme',
  subtitle: 'Ana veriler, onaylar, üretim ve planlama için role dayalı genel görünüm.',
  help: 'Ürün geliştirme yardımını aç',
  refresh: 'Panoyu yenile',
  generatedAt: '{{date}} itibarıyla veriler',
  loading: {
    title: 'Ürün geliştirme panosu yükleniyor',
    description: 'Güncel iş akışı ve planlama sinyalleri hesaplanıyor.',
  },
  error: {
    title: 'Pano yüklenemedi',
    description: 'Sunucu güncel ürün geliştirme sinyallerini hesaplayamadı.',
    retry: 'Yeniden dene',
  },
  empty: {
    title: 'Role özel gösterge yok',
    description: 'Rolünüzün şu anda pano veri alanlarında okuma yetkisi yok.',
  },
  cards: {
    OPEN_WORKFLOWS: {
      title: 'Açık inceleme ve onaylar',
      description: 'Açık bir uzman kararı gerektiren kayıtlar.',
    },
    INCOMPLETE_MATERIALS: {
      title: 'Eksik ham maddeler',
      description: 'Onayı, tedarikçi verisi veya beyan adları eksik son profiller.',
    },
    DECLARATION_WARNINGS: {
      title: 'Beyan uyarıları',
      description: 'Hata, fark veya eksik dil içeren son beyanlar.',
    },
    EXPIRING_VERSIONS: {
      title: 'Süresi dolan sürümler',
      description: '30 gün içinde süresi dolacak onaylı kaynak sürümleri.',
    },
    UPCOMING_PRODUCTION_ORDERS: {
      title: 'Yaklaşan üretim emirleri',
      description: '14 gün içinde başlayacak planlı veya serbest bırakılmış emirler.',
    },
    MATERIAL_SHORTAGES: {
      title: 'Malzeme eksikleri',
      description: 'Son tekrarlanabilir MRP çalışmasının açık önerileri.',
    },
    PRODUCTION_DEVIATIONS: {
      title: 'Üretim sapmaları',
      description: 'Kesin verim veya tüketim farkı bulunan son tamamlamalar.',
    },
  },
  workflows: {
    title: 'İncelemeler ve onaylar',
    subtitle: 'Yalnızca rolünüzün yapabildiği işlemlere ait kuyruklar gösterilir.',
    review: 'İnceleme',
    approval: 'Onay',
    open: 'Kuyruğu aç',
    none: 'Rolünüze atanmış uygulanabilir iş akışı kuyruğu yok.',
  },
  queues: {
    MATERIALS: 'Malzeme profilleri',
    RECIPES: 'Reçeteler ve ürün ağaçları',
    PROCESS_ROUTINGS: 'Proses rotaları',
    DECLARATIONS: 'Beyanlar',
    ANALYSIS: 'Analiz profilleri',
    SPECIFICATIONS: 'Ürün spesifikasyonları',
    LABELS: 'Etiket şablonları',
    CHANGE_REQUESTS: 'Değişiklik talepleri',
  },
  recentRecipes: {
    title: 'Son değiştirilen reçeteler',
    subtitle: 'Rolünüzün görebildiği her reçetenin son düzenlenen sürümü.',
    empty: 'Kullanılabilir reçete sürümü yok.',
    number: 'Numara',
    name: 'Reçete',
    product: 'Çıktı ürünü',
    version: 'Sürüm',
    status: 'Durum',
    changed: 'Değiştirildi',
    open: '{{number}} reçetesini aç',
  },
  deviations: {
    title: 'Verim ve tüketim sapmaları',
    subtitle: 'Son tamamlamalar; yüzdeler sunucuda kesin ondalıklarla hesaplanır.',
    empty: 'Geçerli 30 günlük dönemde fark kaydedilmedi.',
    order: 'Emir',
    product: 'Ürün',
    plannedActual: 'Plan / gerçek',
    yield: 'Çıktı sapması',
    material: 'En büyük malzeme sapması',
    reported: 'Bildirildi',
    unbounded: 'Sınırsız (sıfır plana karşı tüketim)',
    open: '{{number}} üretim emrini aç',
  },
  recipeStatuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    BLOCKED: 'Engellendi',
    ARCHIVED: 'Arşivlendi',
  },
} as const;
